// Actions
export const SET_LOADING = 'setLoading';
export const SET_UPLOAD_LOADING = 'setUploadLoading';

// Mutations
export const STORE_SET_LOADING = 'storeSetLoading';
export const STORE_SET_UPLOAD_LOADING = 'storeSetUploadLoading';

const state = {
    isLoading: false,
    isUploadLoading: false,
};

const getters = {
    isLoading(state) {
        return state.isLoading
    },

    isUploadLoading(state) {
        return state.isUploadLoading
    }
};

const actions = {
    [SET_LOADING](context, loading) {
        context.commit(STORE_SET_LOADING, loading);
    },

    [SET_UPLOAD_LOADING](context, loading) {
        context.commit(STORE_SET_UPLOAD_LOADING, loading);
    },
};

const mutations = {
    [STORE_SET_LOADING](state, loading) {
        state.isLoading = loading;
    },

    [STORE_SET_UPLOAD_LOADING](state, loading) {
        state.isUploadLoading = loading;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}